import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import ChatList from 'components/Chat/ChatList/ChatList';
import './styles.scss';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

const ChatListMobile: React.FC = () => {
	const navigate = useNavigate();

	useEffect(() => {
		!isMobile && navigate('/');
	}, []);

	return isMobile ? (
		<div className="py-4">
			<Container fluid>
				<div className="chat-box d-flex flex-column flex-md-row gap-3 gap-xxl-4">
					<ChatList />
				</div>
			</Container>
		</div>
	) : (
		<></>
	);
};

export default ChatListMobile;
